import { useEffect } from "react";
import applicationConstant from "../_services/applicationConstant";

export function useVersionCheck() {
    const checkVersion = async () => {
      try {
        const currentVersion = localStorage.getItem('app_version');
        const newVersion = applicationConstant.version;

        if (currentVersion && currentVersion !== newVersion) {
          console.log('New version detected — refreshing...');
          localStorage.setItem('app_version', newVersion);
          window.location.reload(true);
        } else {
          localStorage.setItem('app_version', newVersion);
        }
      } catch (err) {
        console.error('Version check failed', err);
      }
    };

    const interval = setInterval(checkVersion, 30000); // every 30s
    checkVersion();

    return () => clearInterval(interval);
}
